import { MutationTree } from 'vuex'
import RootState from './RootState'

const mutations: MutationTree<RootState> = {}

export default mutations
